export const VserverProducts = {
    starter: {
      cores: '1',
      memory: '2048',
      disk: '40',
      hostname_group: 'starter',
      product_name: 'Starter',
      product_key: 'starter',
      vserver_template: 'DEBIAN_10',
      price: 0,
      status: '',
      backups: 3,
      addresses_v4: 1,
      description:{
              introduction:'',
              body:'Produkt Spezifikationen',
              footer:'',
              links:[
                  {url:'/domain'},
                  {url:'/'}
                ]
          },
      graphic:{
        header:'',
        body:'',
        footer:'',
        icon:'fa fa-beer',
      }
    },
    advanced: {
      cores: '4',
      memory: '8192',
      disk: '80',
      hostname_group:'advanced',
      product_name:'Advanced',
      product_key:'advanced',
      vserver_template:'DEBIAN_10',
      price: 0,
      status:' ',
      backups: 3,
      addresses_v4: 1,
      description:{
        introduction:'',
        body:'Produkt Spezifikationen',
        footer:'',
        links:[
          {url:'/domain'},
          {url:'/'}
        ]
      },
      graphic:{
        header:'',
        body:'',
        footer:'',
        icon:'fa fa-circle',
      }
    },
    expert: {
      cores: '8',
      memory: '32784',
      disk: '250',
      hostname_group:'expert',
      product_name:'Expert',
      product_key:'expert',
      vserver_template:'DEBIAN_10',
      price:0,
      status:'',
      backups:3,
      addresses_v4:1,
      description:{
        introduction:'',
        body:'Produkt Spezifikationen',
        footer:'',
        links:[
          {url:'/domain'},
          {url:'/'}
        ]
      },
      graphic:{
        header:'',
        body:'',
        footer:'',
        icon:'fa fa-server',
      },
    },
    custom: {
      cores: '1',
      memory: '1024',
      disk: '10',
      product_name:'Selbst Konfigurieren',
      product_key:'custom',
      hostname_group:'custom',
      vserver_template:'DEBIAN_10',
      price:0,
      status:'',
      backups:3,
      addresses_v4:1,
      description:{
        introduction:'',
        body:'Produkt Spezifikationen',
        footer:'',
        links:[
          {url:'/domain'},
          {url:'/'}
        ]
      },
      graphic:{
        header:'',
        body:'',
        footer:'',
        icon:'fa fa-server',
      }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/vserver_products.js